import API from "./API";

class List {
  static async get(locationId) {
    return API.get("/merchant/waitinglists", {
      needAuth: true,
      params: {
        locationId
      }
    });
  }

  static async create(data) {
    return API.post("/merchant/waitinglists", data, { needAuth: true });
  }

  static async open(id) {
    return API.post(
      `/merchant/waitinglists/${id}/open`,
      {},
      { needAuth: true }
    );
  }

  static async close(id) {
    return API.post(
      `/merchant/waitinglists/${id}/close`,
      {},
      { needAuth: true }
    );
  }

  static async archive(id, data) {
    return API.post(`/merchant/waitinglists/${id}/archive`, data, {
      needAuth: true
    });
  }
}

export default List;
